var _rect, _rect2, _path, _path2, _path3, _rect3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradCapHex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 83,
    viewBox: "0 0 65 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.28662,
    y: 76.7217,
    width: 18.4233,
    height: 6.1283,
    rx: 3.06415,
    fill: "#F9858E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.9609,
    y: 76.7217,
    width: 18.4233,
    height: 6.1283,
    rx: 3.06415,
    fill: "#F9858E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57638 47.1622C1.52097 45.2997 1.52097 43.0199 2.57638 41.1575L15.0583 19.1314C16.1396 17.2234 18.1633 16.0442 20.3563 16.0442L45.125 16.0442C47.3181 16.0442 49.3418 17.2234 50.423 19.1314L62.905 41.1575C63.9604 43.0199 63.9604 45.2997 62.905 47.1622L50.423 69.1883C49.3418 71.0963 47.3181 72.2755 45.125 72.2755H20.3563C18.1633 72.2755 16.1396 71.0963 15.0583 69.1883L2.57638 47.1622Z",
    fill: "#F9858E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7449 51.4254C39.833 51.4254 45.5791 45.5639 45.5791 38.3333C45.5791 31.1027 39.833 25.2412 32.7449 25.2412C25.6567 25.2412 19.9106 31.1027 19.9106 38.3333C19.9106 45.5639 25.6567 51.4254 32.7449 51.4254Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8897 44.0821C33.4449 44.0821 36.3269 41.1787 36.3269 37.5972C36.3269 34.0157 33.4449 31.1123 29.8897 31.1123C26.3346 31.1123 23.4526 34.0157 23.4526 37.5972C23.4526 41.1787 26.3346 44.0821 29.8897 44.0821Z",
    fill: "#570029"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5815,
    y: 6.72656,
    width: 28.7756,
    height: 9.48316,
    fill: "#782E2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.418 0.483674C32.6354 0.431497 32.8621 0.431497 33.0795 0.483674L57.1114 6.25163C58.5599 6.59928 58.5599 8.65984 57.1114 9.00749L33.0795 14.7754C32.8621 14.8276 32.6354 14.8276 32.418 14.7754L8.38609 9.00749C6.93764 8.65984 6.93764 6.59928 8.38609 6.25163L32.418 0.483674Z",
    fill: "#371616"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1559 15.758L14.1559 8.98434L32.3066 4.69434",
    stroke: "#782E2E",
    strokeWidth: 2.36177,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradCapHex);
export default __webpack_public_path__ + "static/media/grad-cap-hex.8abe01e599b347a67754de7b373a5501.svg";
export { ForwardRef as ReactComponent };